// @flow
import createReducer from '../utils/createReducer';

import type {Action} from '../actions/trip';
import type {ActionType} from '../actions/trip';
import type {ActionHandlers} from './ActionHandlers';

export type State = {
    +arrival?: string,
    +departure?: string,
    +adultsCount?: number,
    +childrenCount?: number,
    +petIncluded?: boolean | string
};

const initialState: State = {};

const actionHandlers: ActionHandlers<Action, ActionType, State> = {
    ['TRIP/DATA_CHANGED'](state, {payload}) {
        return {
            ...state,
            ...payload
        };
    }
};

export default createReducer(actionHandlers, initialState);
